import { Mail, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* Main Footer Content */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-[24px] font-light mb-6">Bankelys</h3>
            <p className="text-[#999999] text-[15px] leading-[1.8] mb-6">
              Votre partenaire de confiance en finance bancaire, islamique et commerce international.
            </p>
            <div className="flex gap-4">
              <a
                href="https://linkedin.com/company/bankelys"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://twitter.com/bankelys"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300"
                aria-label="Twitter"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="https://facebook.com/bankelys"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
<div>
  <h4 className="text-[18px] font-normal mb-6 uppercase tracking-[0.1em] text-[11px]">
    Liens Rapides
  </h4>
  <ul className="space-y-3">
    <li>
      <Link 
        to="/" 
        className="text-[#999999] text-[15px] hover:text-white transition-colors duration-300"
      >
        À propos
      </Link>
    </li>
    <li>
      <Link 
        to="/services" 
        className="text-[#999999] text-[15px] hover:text-white transition-colors duration-300"
      >
        Nos Services
      </Link>
    </li>
    <li>
      <Link 
        to="/contact" 
        className="text-[#999999] text-[15px] hover:text-white transition-colors duration-300"
      >
        Contact
      </Link>
    </li>
    <li>
      <Link 
        to="/" 
        className="text-[#999999] text-[15px] hover:text-white transition-colors duration-300"
      >
        Mentions légales
      </Link>
    </li>
  </ul>
</div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[18px] font-normal mb-6 uppercase tracking-[0.1em] text-[11px]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#999999] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span className="text-[#999999] text-[15px] leading-[1.8]">
                  93 Rue de La Palestine Beb  El Bhar, Tunis 1002
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#999999] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <a 
                  href="mailto:contact@bankelys.com" 
                  className="text-[#999999] text-[15px] hover:text-white transition-colors duration-300"
                >
                  contact@bankelys.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#999999] text-[13px]">
              © 2025 Bankelys. Tous droits réservés.
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
}